import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericFormComponent } from 'src/app/shared/generic-form/generic-form.component';

@Component({
  selector: 'app-piattaforma',
  templateUrl: './piattaforma.component.html',
  styleUrls: ['./piattaforma.component.scss'],
})
export class PiattaformaComponent implements OnInit {
  heroData = {
    title: 'In Easycode è importante<br/>imparare divertendosi',
    subtitle:
      'Una piattaforma dove la tecnologia è al servizio dei ragazzi/e, dove tutti hanno la possibilità di imparare e conoscere ciò che li aiuterà nel percorso accademico o lavorativo',
    imgSrc: '../../../assets/img/floppy_platform.png',
    class: 'floppy-platform',
  };

  slideSelected:number = 1;
  isProcessing = false;
  @ViewChild('myElement') myElement!: ElementRef; // Referenza all'elemento nel template

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    const element = this.myElement.nativeElement;
    const mc = new Hammer(element);



    // Aggiungi i riconoscitori per gestire eventi specifici
    mc.on('panleft panright', (ev: any) => {
      if (this.isProcessing) {
        // Se già in fase di elaborazione, ignora gli eventi successivi
        return;
      }

      this.isProcessing = true; // Blocca ulteriori azioni temporaneamente

      if (ev.type === 'panright') {
        if (this.slideSelected > 1) {
          this.slideSelected--;
        } else {
          this.slideSelected = 4;
        }
      } else if (ev.type === 'panleft') {
        if (this.slideSelected < 4) {
          this.slideSelected++;
        } else {
          this.slideSelected = 1;
        }
      }

      // Attendi un secondo prima di consentire ulteriori azioni
      setTimeout(() => {
        this.isProcessing = false; // Sblocca dopo il tempo di attesa
      }, 500); // Attesa di 1 secondo
    });


  }


  openModal(type: string) {
    const modalRef = this.modalService.open(GenericFormComponent, {
      size: 'lg',
      modalDialogClass: 'signup-modal',
      centered: true,
    });
    modalRef.componentInstance.type = type;
  }

  redirectToApp() {
    console.log('redirect to https://app.easycode.org/');
    window.location.href = 'https://app.easycode.org/';
  }

  changeSlide(id: number) {
    this.slideSelected = id;
  }


}
